import type { IBasketItem } from '../modules/basket/models';

export const normalizeLimit = (raw?: number | null) =>
  raw == null || raw === 0 ? null : Math.max(1, Math.min(100, raw));

// Produkt identyfikuje wyłącznie `id` (UUID). Pozycja koszyka ma własne `id`
// (linii), więc produkt bierzemy z `item.id`.
export const inBasketQtyForProduct = (items: IBasketItem[], product: any) => {
  const key = String(product?.id ?? '');
  if (!key) return 0;
  return items.reduce(
    (acc, it) => acc + (String(it.item?.id ?? '') === key ? it.quantity || 0 : 0),
    0
  );
};
